export const PublicWebUrl = {
  homepage: '/',
  event: '/event',
  category: '/event/category',
  invoice: '/event/payment-confirmation/:token',
};
